import styled from '@emotion/styled'
import { SKIP_DOLLAR_PROPS } from '@helpers/styles'
import { ListItemIcon } from '@mui/material'

interface SelectableItem {
	$isSelected: boolean
}

export const StyledLabel = styled('h6')<SelectableItem>`
	font-size: 1rem;
	line-height: 1.5;
	margin: 0;
	${({ $isSelected, theme }) => `
        color: ${
					$isSelected ? theme.palette.primary.main : theme.palette.fonts.primary
				};
    `}
`

export const StyledListItemIcon = styled(
	ListItemIcon,
	SKIP_DOLLAR_PROPS
)<SelectableItem>`
	height: ${({ theme }) => theme.spacing(6)};
	align-items: center;
	justify-content: center;
	align-content: center;
	margin: 0px 10px;
	min-width: ${({ theme }) => theme.spacing(6)} !important;
	padding: 0;
	${({ theme, $isSelected }) =>
		$isSelected && `background:   ${theme.palette.primary.main}`};
	& path: {
		fill: ${({ theme, $isSelected }) =>
			$isSelected && theme.palette.secondary.contrastText};
	}
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	svg {
		rect,
		path {
			fill: ${({ theme }) => theme.palette.common.white};
		}
	}
`
